import React, { useState } from "react"
import { Paper, Grid, Box, Tooltip } from "@material-ui/core"
import {
  InputTextMaster,
  MasterButton,
  InputCheckboxMaster,
  IconButtonDatatable,
} from "App/Component/ui"
import {
  RESET_STATE_PROFILE_REKAM_MEDIS,
  STYLE_MASTER_GUDANG_UTAMA,
  FormAsuransi,
  FormDataPasien,
  urlAddPatientExternal,
  urlAddPatientInternal,
  urlUpdatePatientInternal,
  urlUpdatePatientExternal,
  FormAlamat,
  FormPenanggung,
  FormMediaSosial,
  syncSatuSehatSatuan,
  usePrintPdf,
  validateRM,
} from "."
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance2,
  REK_MED,
} from "App/constants"

import {
  defaultToastError,
  defaultToastSuccess,
  convertDateToValidInput,
  removeLocalStorageAsFormData,
  isNull,
  today,
  scrollToTop,
} from "App/utils/helpers"

import DatePicker from "react-datepicker"
import { SelectIcon } from "App/Assets"
import { getSearchSEP, prefixNoRM } from "../../utils"
import { useDispatchWrapper } from "hooks"
import moment from "moment"
import { KODE_PRINTER_SETTING, messageError, URL_SETTING } from "utils/all"
import { useSelector } from "react-redux"
import { getToken } from "App/utils/cookies"
import SatuSehat from "App/Assets/icons/SatuSehat"
import { Sync, SyncDisabled } from "@material-ui/icons"

export default function FormProfileRekamMedis({
  formData,
  setFormData,
  setNewData,
  rekamMedisId,
  setRekamMedisId,
  photo,
  setPhoto,
  firstVisit,
  setFirstVisit,
}) {
  const classes = STYLE_MASTER_GUDANG_UTAMA()
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT)
  const { setting } = useSelector((state) => state)
  const printerEnv = setting.printer_env
  const [loading, setLoading] = useState(false)

  const { handleClickPDF, loadingPrint } = usePrintPdf()

  const syncSatuan = async () => {
    if (isNull(rekamMedisId)) {
      return defaultToastError("Harap pilih pasien terlebih dahulu !")
    } else {
      setLoading(true)
      const res = await syncSatuSehatSatuan(rekamMedisId)
      if (res.state) {
        defaultToastSuccess(res.message)
      } else {
        defaultToastError(res.message)
      }
      setLoading(false)
    }
  }

  const add = async (url) => {
    return instance2.post(url, {
      ...formData,
      date_ob: formData.date_ob_form,
      country: formData.country,
      first_visit: convertDateToValidInput(firstVisit),
      photo: photo,
      is_same_with_ktp: formData.is_same_with_ktp,
    })
  }

  const update = async (url, header) => {
    return instance2.post(
      url,
      {
        ...formData,
        date_ob: formData.date_ob_form,
        country: formData.country,
        first_visit: convertDateToValidInput(firstVisit),
        photo: photo,
        is_same_with_ktp: formData.is_same_with_ktp,
      },
      {
        headers: header,
      },
    )
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      if (validateRM(formData)) {
        setDisabled(DISABLED_BUTTON_SUBMIT)
        if (isNull(rekamMedisId)) {
          if (
            formData.external === 0 ||
            formData.external === false ||
            formData.external === undefined
          ) {
            await add(urlAddPatientInternal)
          } else {
            await add(urlAddPatientExternal)
          }
          defaultToastSuccess("Berhasil menambah Rekam Medis")
        } else if (!isNull(rekamMedisId)) {
          if (
            formData.external === 0 ||
            formData.external === false ||
            formData.external === undefined
          ) {
            const header = {
              idpatients: rekamMedisId,
            }
            await update(urlUpdatePatientInternal, header)
          } else {
            const header = {
              idpatients_external: rekamMedisId,
            }
            await update(urlUpdatePatientExternal, header)
          }
          defaultToastSuccess("Berhasil mengubah Rekam Medis")
        }
        setFormData(RESET_STATE_PROFILE_REKAM_MEDIS)
        setRekamMedisId("")
        setPhoto(null)
        setNewData()
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      } else {
        return
      }
    } catch (error) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      defaultToastError(error?.response?.data?.message)
    }
  }

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    })
  }

  const handleChangeAsuransi = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    })
  }

  const { state } = useDispatchWrapper()
  const handleClickSearchSepByNik = async () => {
    const response = await getSearchSEP({
      type: "2",
      nomor_kartu: formData.nik,
      tgl_pelayanan: today(),
    })

    if (response.state) {
      const dataRes = response.data.peserta
      setFormData({
        ...formData,
        fullname: dataRes.nama,
        date_ob_form: dataRes.tglLahir,
        mobile_phone_number: dataRes.mr.noTelepon,
        phone_number: dataRes.mr.noTelepon,
        gender: dataRes.sex === "P" ? "2" : "1",
        insurance_id: state.wrapper_insurance_bpjs_id,
        insurance_name: "BPJS",
        insurance_number: dataRes.noKartu,
      })
    } else {
      defaultToastError(response.message)
    }
  }

  const handleClickPrintKartuPasien = () => {
    const jenisKelamin = formData.gender === "1" ? "LAKI-LAKI" : "PEREMPUAN"
    const tanggalLahir = `${moment(formData.date_ob)
      .local()
      .format("dddd")}, ${moment(formData.date_ob)
      .local()
      .format("MM")} ${moment(formData.date_ob)
      .local()
      .format("MMMM")} ${moment(formData.date_ob).local().format("YYYY")}`

    return window.open(
      `http://localhost/${
        process.env.REACT_APP_PRINT_NAME
      }/public/api/print-kartu-rm?nama=${
        formData.fullname
      }&jenisKelamin=${jenisKelamin}&noRM=${prefixNoRM(
        rekamMedisId,
      )}&tglLahir=${tanggalLahir}&alamat=${
        formData.address_now
      }&nama_rumah_sakit=${printerEnv.nama_rumah_sakit}&fax_rumah_sakit=${
        printerEnv.fax_rumah_sakit
      }&no_tlp_rumah_sakit=${printerEnv.no_tlp_rumah_sakit}&kota_rumah_sakit=${
        printerEnv.kota_rumah_sakit
      }&jalan_rumah_sakit=${printerEnv.jalan_rumah_sakit}&kec_rumah_sakit=${
        printerEnv.kec_rumah_sakit
      }&logo_rumah_sakit=${
        printerEnv.logo_rumah_sakit
      }&token=${getToken()}&url_setting=${URL_SETTING}&kode_setting=${
        KODE_PRINTER_SETTING.printer_kartu_rm
      }`,
      "MsgWindow",
    )
  }

  const handleClickPrintKartuRM = () => {
    const jenisKelamin = formData.gender === "1" ? "LAKI-LAKI" : "PEREMPUAN"
    const tanggalLahir = `${moment(formData.date_ob)
      .local()
      .format("dddd")}, ${moment(formData.date_ob)
      .local()
      .format("MM")} ${moment(formData.date_ob)
      .local()
      .format("MMMM")} ${moment(formData.date_ob).local().format("YYYY")}`

    return window.open(
      `http://localhost/${
        process.env.REACT_APP_PRINT_NAME
      }/public/api/print-kartu-rm?nama=${
        formData.fullname
      }&jenisKelamin=${jenisKelamin}&noRM=${prefixNoRM(
        rekamMedisId,
      )}&tglLahir=${tanggalLahir}&alamat=${
        formData.address_now
      }&nama_rumah_sakit=${printerEnv.nama_rumah_sakit}&fax_rumah_sakit=${
        printerEnv.fax_rumah_sakit
      }&no_tlp_rumah_sakit=${printerEnv.no_tlp_rumah_sakit}&kota_rumah_sakit=${
        printerEnv.kota_rumah_sakit
      }&jalan_rumah_sakit=${printerEnv.jalan_rumah_sakit}&kec_rumah_sakit=${
        printerEnv.kec_rumah_sakit
      }&logo_rumah_sakit=${
        printerEnv.logo_rumah_sakit
      }&token=${getToken()}&url_setting=${URL_SETTING}&kode_setting=${
        KODE_PRINTER_SETTING.printer_kartu_rm
      }`,
      "MsgWindow",
    )
  }

  return (
    <Paper className={classes.paper}>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid item xs={12}>
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Grid item xs={8}>
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <p style={{ fontSize: "24px", marginTop: "0.4rem" }}>
                    ID Rekam Medis
                  </p>
                  <Box display="flex" flexDirection="row" alignItems="center">
                    <p style={{ fontSize: 30, marginTop: "0" }}>
                      {" "}
                      {rekamMedisId === "" ? "-" : rekamMedisId}{" "}
                    </p>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "15px",
                      marginTop: "0.5rem",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <SatuSehat width="35" height="35" />
                      <span style={{ fontWeight: "700", fontSize: "20px" }}>
                        SATUSEHAT
                      </span>
                    </div>
                    <IconButtonDatatable
                      style={{
                        backgroundColor: isNull(rekamMedisId) ? "" : "#296218",
                      }}
                      onClick={() =>
                        isNull(rekamMedisId) ? null : syncSatuan()
                      }
                    >
                      <Tooltip
                        title={"Singkronisasi Satu Sehat"}
                        aria-label="delete"
                      >
                        {isNull(rekamMedisId) || loading ? (
                          <SyncDisabled
                            fontSize={"small"}
                            style={{ color: "#fff" }}
                          />
                        ) : (
                          <Sync fontSize={"small"} style={{ color: "#fff" }} />
                        )}
                      </Tooltip>
                    </IconButtonDatatable>
                  </div>

                  <Box display="flex" flexDirection="row" alignItems="center">
                    <p style={{ fontSize: 30 }}>
                      {" "}
                      {isNull(formData.id_ihs) ? "-" : formData.id_ihs}{" "}
                    </p>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={4}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "1rem",
                }}
              >
                <div>
                  <InputCheckboxMaster
                    checked={formData.external}
                    name="external"
                    id="external"
                    label="External"
                    onChange={() =>
                      setFormData({ ...formData, external: !formData.external })
                    }
                  />
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <div className="mt-1">
          <Grid container spacing={1}>
            <Grid item sm={4}>
              <div
                style={{
                  display: "flex",
                }}
              >
                <InputTextMaster
                  name="nik"
                  label="NIK"
                  id="nik"
                  autoFocus={true}
                  value={formData.nik}
                  placeholder="NIK"
                  onChange={handleChange("nik")}
                  error={true}
                  message={messageError.required}
                />

                <MasterButton
                  type={"button"}
                  color="lightgreen"
                  name=""
                  size="sm"
                  withIcon={true}
                  onClick={() => handleClickSearchSepByNik()}
                  style={{
                    marginTop: "1.5rem",
                    width: "32px",
                    height: "32px",
                  }}
                  icon={
                    <SelectIcon
                      width="16px"
                      height="16px"
                      style={{
                        marginLeft: "-0.5rem",
                      }}
                    />
                  }
                />
              </div>

              <span
                style={{
                  fontSize: "10px",
                  color: "gray",
                }}
              >
                Button disamping NIK digunakan untuk mengambil data dari BPJS by
                NIK
              </span>
            </Grid>
            <Grid item sm={4}>
              <InputTextMaster
                name="no_kk"
                label="NOMOR KK"
                id="no_kk"
                placeholder="Nomor Kartu Keluarga"
                value={formData.no_kk}
                onChange={handleChange("no_kk")}
                error={true}
              />
            </Grid>
            <Grid item sm={4}>
              <InputTextMaster
                name="no_paspor"
                label="NOMOR PASPOR"
                id="no_paspor"
                placeholder="Nomor Paspor"
                value={formData.no_paspor}
                onChange={handleChange("no_paspor")}
                error={true}
              />
            </Grid>

            <Grid item sm={4}>
              <InputTextMaster
                name="fullname"
                label="NAMA"
                id="fullname"
                placeholder="Nama"
                value={formData.fullname}
                onChange={handleChange("fullname")}
                error={true}
                message={messageError.required}
              />
            </Grid>
            <Grid item sm={4}>
              <InputTextMaster
                name="nama_ibu"
                label="NAMA IBU KANDUNG"
                id="nama_ibu"
                placeholder="Nama Ibu Kandung"
                value={formData.nama_ibu}
                onChange={handleChange("nama_ibu")}
                error={true}
              />
            </Grid>
            <Grid item sm={4}>
              <label htmlFor="first_visit_form" className="form-control-label">
                KUNJUNGAN PERTAMA
              </label>
              <DatePicker
                id="first_visit_form"
                autoComplete="off"
                className="form-control text"
                dateFormat="dd/MM/yyyy"
                selected={firstVisit}
                onChange={(e) => {
                  setFirstVisit(e)
                }}
                minDate={new Date()}
                placeholderText="Tanggal"
                error={true}
                message={messageError.required}
              />
            </Grid>
            {/* <Grid item sm={4}>
              <InputTextMaster
                name='id_ihs'
                label='IHS'
                id='id_ihs'
                placeholder='IHS'
                value={formData.id_ihs}
                onChange={handleChange("id_ihs")}
                error={true}
              />
            </Grid> */}
          </Grid>
        </div>
        <FormDataPasien
          handleChange={handleChange}
          formData={formData}
          setFormData={setFormData}
          photo={photo}
          setPhoto={setPhoto}
        />
        <FormAlamat
          handleChange={handleChange}
          formData={formData}
          setFormData={setFormData}
        />

        <FormAsuransi
          handleChange={handleChangeAsuransi}
          handleChanges={handleChange}
          formData={formData}
          setFormData={setFormData}
        />
        <FormPenanggung handleChange={handleChange} formData={formData} />
        <FormMediaSosial
          handleChange={handleChange}
          formData={formData}
          setFormData={setFormData}
        />

        <div className="mt-1">
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <MasterButton
              className={"mt-1"}
              type="button"
              color="danger"
              name="Reset"
              onClick={() => {
                setFirstVisit(new Date())
                setRekamMedisId("")
                removeLocalStorageAsFormData(REK_MED)
                setFormData(RESET_STATE_PROFILE_REKAM_MEDIS)
                scrollToTop()
              }}
              size="md"
            />

            <div
              style={{
                display: "flex",
                gap: "20px",
              }}
            >
              {!isNull(rekamMedisId) && (
                <>
                  <MasterButton
                    className={"mt-1"}
                    type="button"
                    color={"purple"}
                    name={loadingPrint ? "Loading..." : "CETAK KARTU PASIEN"}
                    onClick={() =>
                      loadingPrint
                        ? null
                        : handleClickPDF({
                            no_rm: rekamMedisId,
                            fullname: formData.fullname,
                          })
                    }
                    size="md"
                  />

                  <MasterButton
                    className={"mt-1"}
                    type="button"
                    color={"warning"}
                    name={"CETAK KARTU RM"}
                    onClick={() => handleClickPrintKartuRM()}
                    size="md"
                  />
                </>
              )}

              <MasterButton
                className={"mt-1"}
                type="submit"
                color={disabled.color}
                name={disabled.label}
                disabled={disabled.state}
                size="md"
              />
            </div>
          </Grid>
        </div>
      </form>
    </Paper>
  )
}
